// Christian Jesus T-Shirts Theme JS

document.addEventListener('DOMContentLoaded', function() {
  // Mobile drawer menu
  const menuToggle = document.querySelector('.menu-toggle');
  const drawer = document.querySelector('.mobile-drawer');
  const overlay = document.querySelector('.mobile-drawer-overlay');
  const drawerClose = document.querySelector('.mobile-drawer-close');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('open');
    document.body.classList.add('drawer-open');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('open');
    document.body.classList.remove('drawer-open');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
  }

  if (menuToggle) menuToggle.addEventListener('click', openDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  // Newsletter form enhancement
  const newsletterForms = document.querySelectorAll('.newsletter-form');
  newsletterForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      // Shopify handles the submission
    });
  });

  // Cart drawer / cart count updates
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const countEl = document.querySelector('.cart-count');
        if (countEl) {
          countEl.textContent = cart.item_count;
          countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      });
  }

  // Product form AJAX add to cart
  const productForms = document.querySelectorAll('form[action="/cart/add"]');
  productForms.forEach(form => {
    form.addEventListener('submit', async function(e) {
      if (form.dataset.ajax === 'false') return;
      e.preventDefault();
      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) submitBtn.innerHTML = 'Adding...';

      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        if (response.ok) {
          if (submitBtn) submitBtn.innerHTML = '✓ Added!';
          updateCartCount();
          setTimeout(() => {
            if (submitBtn) submitBtn.innerHTML = originalText;
          }, 2000);
        } else {
          if (submitBtn) submitBtn.innerHTML = originalText;
        }
      } catch (err) {
        console.error(err);
        if (submitBtn) submitBtn.innerHTML = originalText;
      }
    });
  });
});
